import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidC_Video2 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoDavidC2 = () => {
  return (
    <>
      <ModalVideo
        id="david-video-2"
        dataText={DavidC_Video2}
        videoSrc="https://www.youtube.com/embed/rsH_GAmI50A?si=_I5x2YgLiaIqKvze"
        videoTitle="KUTER_STUDIO_AI_DAVID_C_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoDavidC2;
